var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { ConfigProvider } from 'antd';
import hoistNonReactStatic from 'hoist-non-react-statics';
export { ConfigContext as AntdConfigContext, ConfigConsumer, } from 'antd/es/config-provider';
const Default = (props) => {
    const { prefixCls = 'oss-ui', configPath, children } = props, restProps = __rest(props, ["prefixCls", "configPath", "children"]);
    return (<ConfigProvider prefixCls={prefixCls} {...restProps}>
            {children}
        </ConfigProvider>);
};
hoistNonReactStatic(Default, ConfigProvider);
export default Default;
